import { render, staticRenderFns } from "./BulkMarkAsReadModal.vue?vue&type=template&id=46a0c5b8&scoped=true"
import script from "./BulkMarkAsReadModal.vue?vue&type=script&lang=js"
export * from "./BulkMarkAsReadModal.vue?vue&type=script&lang=js"
import style0 from "./BulkMarkAsReadModal.vue?vue&type=style&index=0&id=46a0c5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0c5b8",
  null
  
)

export default component.exports